import { Modal } from "@heroui/react";
import { ArrowRight } from "@gravity-ui/icons";
import LightboxButton from "./LightboxButton";
import type { CaseView } from "./caseView";
import { productFor } from "./caseProduct";
import styles from "./FirstClue.module.scss";

/* UI-DESIGN: LB-77 (Taco 2026-10-16) "Preview a role": the case card's
   second action shows one guest's character card instead of the first
   clue, since who you get to be is what sells the night. Same overlay and
   paper card as the old first-clue preview (FirstClue.module.scss), with
   Try this case as the way on. HeroUI Modal for focus trap, Escape and the
   backdrop. DRAFT for Avi: the role text lives in caseProduct.ts. */
type RolePreviewProps = {
  view: CaseView | null;
  onClose: () => void;
  onHost: (view: CaseView) => void;
  canHost: boolean;
};

const RolePreview = ({ view, onClose, onHost, canHost }: RolePreviewProps) => {
  const role = view ? productFor(view).role : null;
  return (
    <Modal>
      <Modal.Backdrop variant="blur" className={styles.backdrop} isOpen={Boolean(view)} onOpenChange={(open) => (open ? undefined : onClose())}>
        <Modal.Container placement="center" className={styles.container}>
          <Modal.Dialog className={styles.dialog} aria-labelledby="lb-role-title">
            {view ? (
              <>
                <Modal.Header className={styles.header}>
                  <Modal.Heading id="lb-role-title" className={styles.title}>
                    {view.name}: preview a role
                  </Modal.Heading>
                </Modal.Header>
                <Modal.Body className={styles.body}>
                  <figure className={styles.card} data-lb-contrast="">
                    <p className={styles.cardHead}>{role ? `${role.label}: ${role.name}` : "Your character"}</p>
                    <blockquote className={styles.clue}>{role?.text ?? view.premise}</blockquote>
                    {role?.note ? <figcaption className={styles.note}>{role.note}</figcaption> : null}
                  </figure>
                  <p className={styles.sub}>Every guest gets a character like this, plus a few secrets about the people next to them.</p>
                </Modal.Body>
                <Modal.Footer className={styles.footer}>
                  <LightboxButton tone="primary" trailing={<ArrowRight />} isDisabled={!canHost} onPress={() => onHost(view)}>
                    Try this case
                  </LightboxButton>
                  <LightboxButton tone="quiet" onPress={onClose}>
                    Close
                  </LightboxButton>
                </Modal.Footer>
              </>
            ) : null}
          </Modal.Dialog>
        </Modal.Container>
      </Modal.Backdrop>
    </Modal>
  );
};

export default RolePreview;
